/** A store type of the moderno channel. */
export function isModernoStoreType(storeType) {
    return storeType?.channel === 'moderno';
}

/** A moderno segment that is a client: its value is the client's id (24 hex characters). */
export function isClientSegment(storeType) {
    return /^[0-9a-f]{24}$/i.test(String(storeType?.value ?? ''));
}
